module.exports = __webpack_public_path__ + "media/images/flags/russia-16ff88b6fbe9c047dd5c9eafea87c9d6.jpg";